import React from 'react';

import IPhoneComponent from './iPhone';

import ColorSelector from './ColorSelector';
import { FacebookShareButton } from '@vz/ui/pkg/Social/Facebook/Share';
import { TwitterShareButton } from '@vz/ui/pkg/Social/Twitter/Share';

import S from './iPhonePage.module.css';

export default function IPhone() {
  // const router = useRouter();
  // console.log(router);
  return (
    <div className={S.root}>
      <h1>Imageless iPhone 4</h1>
      <div className={S.share}>
        <FacebookShareButton />
        <TwitterShareButton
          text="Imageless iPhone 4 in pure CSS! Awesome creation!"
          via="Vasyl_Zubach"
        />
      </div>

      <div className={S.wrapper}>
        <div className={S.block} style={{ display: 'flex' }}>
          <div className={S.demo}>
            <IPhoneComponent isLocked={false} isOn />
          </div>
        </div>
        <div className={S.block}>
          <h2>Customize color:</h2>
          <ColorSelector />

          <h2>Description:</h2>
          <p>
            This rendering of iPhone 4 and its icons were made in pure CSS3. No
            images, no base64, no SVG, no canvas, just a lot of CSS3 and a
            little bit of Javascript.
          </p>

          <p>Viewed best with the latest browsers versions</p>

          <h2>iPhone features (like in a real iPhone):</h2>
          <ul>
            <li>iPhone states: lock/unlock, on/off;</li>
            <li>the sound of unlocking and turning off;</li>
            <li>icon animations;</li>
            <li>&quot;slide to unlock&quot; letter animation;</li>
            <li>iPhone Alert message;</li>
            <li>ability to customize the color of the iPhone.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
